import { Component, inject, input, output, signal } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { heroXMark } from '@ng-icons/heroicons/outline';
import { MyHistoryUiService } from 'app/my-history/my-history-ui.service';
import { IconComponent } from 'app/shared/icon/icon.component';

@Component({
  selector: 'app-inline-dialog',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './inline-dialog.component.html',
  styles: ``,
  providers: [provideIcons({ heroXMark })],
  host: {
    class:
      'overflow-auto min-h-[650px] absolute block bg-white rounded-t-2xl shadow z-10 top-6 right-0 lg:w-[900px] md:w-[500px]',
  },
})
export class InlineDialogComponent {
  checkBeforeClosing = input(false);
  noCloseIcon = input(false);
  opened = signal(false);
  openedChange = output<boolean>();

  private uiServise = inject(MyHistoryUiService);

  close() {
    this.opened.set(false);
    this.openedChange.emit(false);
    if (!this.checkBeforeClosing()) {
      this.uiServise.closeAllDialogs();
    }
  }

  open() {
    this.opened.set(true);
    this.openedChange.emit(true);
  }
}
